import { Component, EventEmitter, Input, Output, QueryList, ViewChildren, input, output } from "@angular/core";
import Swal from "sweetalert2";
import { FeatherIconsComponent } from "../feather-icons/feather-icons.component";
import { RoundedPaginationComponent } from "../rounded-pagination/rounded-pagination.component";
import { GridService } from "../../services/utils/grid.service";
import { PercentagePipe } from "../../../models/pipes/percentage.pipe";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { localStorageConstants } from "../../../consts/local_storage_constants";
import { jwtDecode } from "jwt-decode";

@Component({
  selector: 'app-card',
  imports: [FeatherIconsComponent, RoundedPaginationComponent, PercentagePipe, NgbTooltip],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss'
})
export class CardComponent {

  @Input() obj: any;
  @Output() actionAddEmit = new EventEmitter();
  @Output() actionEditEmit = new EventEmitter();
  @Output() actionDeleteEmit = new EventEmitter();
  @Output() actionActiveEmit = new EventEmitter();
  @Output() actionGoToEmit = new EventEmitter();
  @Output() actionGoToUsersEmit = new EventEmitter();
  @Output() actionSearchEmit = new EventEmitter();
  @Output() actionViewEmit = new EventEmitter();
  @Output() actionRequestExamEmit = new EventEmitter();
  @Output() actionAnswerQuestionEmit = new EventEmitter();
  @Output() actionStudentsEmit = new EventEmitter();
  @Output() actionExamEmit = new EventEmitter();
  @Output() actionLicensesEmit = new EventEmitter();
  @Output() actionCertificatesEmit = new EventEmitter();
  @Output() actionArchiveRestoreEmit = new EventEmitter();
  tokenInfo:any

  public col_xl_12: boolean = false;
  public col_xl_2: boolean = false;
  public col_sm_3: boolean = false;
  public col_xl_3: boolean = true;
  public xl_4: boolean = true;
  public col_sm_4: boolean = false;
  public col_xl_4: boolean = false;
  public col_sm_6: boolean = true;
  public col_xl_6: boolean = false;
  public gridOptions: boolean = true;
  public active: boolean = false;

  public isShow: boolean = false;
  public searchValue: string = "";
  public listView: boolean = false;
  public isAdmin: boolean = false;


  constructor(public gridService: GridService) { }

  ngOnInit() {
    
    const token: any = localStorage.getItem(localStorageConstants.PORTAL_TOKEN);
    this.tokenInfo = this.getDecodedAccessToken(token); 
    this.isAdmin = this.tokenInfo.role === "Admin"
    if (!this.obj) {
      this.obj = {
        searchTerm: "",
        labelBtnAdd: "add",
        headers: [
          { name: "col1", detail: "col 1" },
          { name: "col2", detail: "col 2" },
          { name: "col3", detail: "col 3" },
          { name: "col4", detail: "col 4" },
          { name: "col5", detail: "col 5" },
          { name: "col6", detail: "col 6", type: "date" },
          { name: "col1", detail: "button X", type: "button", action: () => { alert("test"); } },
          { name: "actions", detail: "Actions", options: "edit,goto,delete" }
        ],
        itemList: [
          { col1: "test", col2: "test", col3: "test2354", col4: "test", col5: "test", col6: "20/10/2021" },
          { col1: "test2", col2: "test3", col3: "test2345", col4: "test", col5: "test", col6: "20/10/2021" },
          { col1: "test3", col2: "test33", col3: "test2345", col4: "test", col5: "test", col6: "20/10/2021" },
          { col1: "test4", col2: "test4555", col3: "test445", col4: "test35", col5: "test345", col6: "20/10/2021" },
          { col1: "test4", col2: "test4555", col3: "test445", col4: "test35", col5: "test345", col6: "20/10/2021" },
        ],
      }
    }
  }

  actionAdd() {
    this.actionAddEmit.emit();
  }

  actionEdit(item: any) {
    this.actionEditEmit.emit(item);
  }

  actionDelete(item: any) {
    Swal.fire({
      text: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    }).then((result) => {
      if (result.isConfirmed) {
        this.actionDeleteEmit.emit(item);
      }
    });
  }
  actionActive(item: any) {
    this.actionActiveEmit.emit(item);
  }

  actionArchiveRestore(item: any){
    this.actionArchiveRestoreEmit.emit(item);
  }

  actionSearch({ value }: any) {
    this.actionSearchEmit.emit({ value: value, page: 0 });
    this.searchValue = value;
  }

  textLong(value: any) {
    if (typeof value == "string") {
      if (value.length > 60) {
        return value.substring(0, 60) + "...";
      } else {
        return value;
      }
    }
    return value;
  }

  calculatePage() {
    if (this.obj.paginator.page < 1) {
      this.obj.paginator.page++;
      return;
    }
    this.actionSearchEmit.emit({ value: this.searchValue, page: this.obj.paginator.page });
  }
  includeInactive(e: any) {
    this.obj.includeInactive = e.srcElement.checked;
    sessionStorage.setItem("courseStatusFilter", this.obj.includeInactive);
    this.actionSearch({ value: this.searchValue })
  }
  gridOpens() {
    this.listView = false;
    this.gridService.gridOpen()
  }
  listOpens() {
    this.listView = true;
    this.gridService.listOpen()
  }
  grid2s() {
    this.listView = false;
    this.gridService.grid2()
  }
  grid3s() {
    this.listView = false;
    this.gridService.grid3()
  }
  grid6s() {
    this.listView = false;
    this.gridService.grid6()
  }

  ngDoCheck() {
    this.col_xl_12 = this.gridService.col_xl_12;
    this.col_xl_2 = this.gridService.col_xl_2;
    this.col_sm_3 = this.gridService.col_xl_12;
    this.col_xl_3 = this.gridService.col_xl_3;
    this.xl_4 = this.gridService.xl_4;
    this.col_sm_4 = this.gridService.col_sm_4;
    this.col_xl_4 = this.gridService.col_xl_4;
    this.col_sm_6 = this.gridService.col_sm_6;
    this.col_xl_6 = this.gridService.col_xl_6;
  }

  formatDescription(description: string) {
    if (!description) {
      return;
    }
    if (!this.col_xl_12)
      return description.substring(0, 20) + "...";
    else return description.substring(0, 100) + "...";;
  }

  actionView(item: any) {
    this.actionViewEmit.emit(item);
  }

  actionAnswer(item: any) {
    this.actionAnswerQuestionEmit.emit(item);
  }

  actionStudents(item: any) {
    this.actionStudentsEmit.emit(item);
  }

  actionGoTo(item: any) {
    this.actionGoToEmit.emit(item);
  }
  actionGoToUsers(item: any) {
    this.actionGoToUsersEmit.emit(item);
  }

  actionExam(item: any) {
    this.actionExamEmit.emit(item);
  }

  actionLicenses(item: any) {
    this.actionLicensesEmit.emit(item);
  }

  actionCertificates(item: any) {
    this.actionExamEmit.emit(item);
  }

       getDecodedAccessToken(token: string): any {
          try {
            return jwtDecode(token);
          } catch (Error) {
            return null;
          }
        }
        


}

